<template>
  <div class="pay-result-page">
    <div class="pay-result-box">
      <van-icon name="checked" size="1rem" color="#4caf50" />
      <div class="pay-result-title">支付完成</div>
      <div class="pay-result-tip">正在返回，请稍候...</div>
      <div class="pay-result-btn" @click="goHome">立即返回</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'payResult',
  data() {
    return {
      targetUrl: '/#/',
    };
  },
  created() {
    // hash 模式下订单号在 #/payResult?orderNo= 中，$route.query 可直接取
    let orderNo = this.$route.query.orderNo || '';
    if (!orderNo) {
      try {
        orderNo = sessionStorage.getItem('gateway_pending_order') || '';
      } catch (e) {}
    }
    this.targetUrl = '/#/?payback=' + encodeURIComponent(orderNo);
    // 网关 returnUrl 在 iframe 内打开，需让顶层窗口跳出 iframe
    setTimeout(() => {
      this.jump();
    }, 800);
  },
  methods: {
    jump() {
      try {
        if (window.top && window.top !== window.self) {
          window.top.location.replace(this.targetUrl);
        } else {
          window.location.replace(this.targetUrl);
        }
      } catch (e) {
        // 跨域异常兜底
        window.location.replace(this.targetUrl);
      }
    },
    goHome() {
      this.jump();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../static/css/common.css';

.pay-result-page {
  min-height: 100vh;
  background: #1e1f24;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pay-result-box {
  text-align: center;
}

.pay-result-title {
  margin-top: 0.3rem;
  font-size: 0.4rem;
  color: #fff;
  font-weight: bold;
}

.pay-result-tip {
  margin-top: 0.2rem;
  font-size: 0.26rem;
  color: #999;
}

.pay-result-btn {
  display: inline-block;
  margin-top: 0.5rem;
  padding: 0.18rem 0.8rem;
  border-radius: 0.4rem;
  background: #DFB372;
  color: #1a1a1a;
  font-size: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/payResult.vue